// Page labels follow their actual on-page heading, not a fixed scroll offset.
(() => {
  if (window.rrPageHeader) return;
  window.rrPageHeader = true;
  const config = document.querySelector('script[data-rr-page-title]');
  let text = config?.dataset.rrPageTitle;
  const policyHeading = document.querySelector('.shopify-policy__title h1');
  if (config?.dataset.rrPageKind === 'policy' && policyHeading) text = policyHeading.textContent.trim();
  const header = document.querySelector('.shopify-section--header');
  const menu = header?.querySelector('button[aria-controls="sidebar-menu"]');
  const main = document.querySelector('main');
  if (!text || !header || !menu || !main) return;
  const normalize = value => value.trim().toLowerCase().replace(/^our\s+/, '').replace(/&/g, 'and').replace(/\s+/g, ' ');
  const group = document.createElement('div');
  group.className = 'rr-collection-header rr-page-header';
  const label = document.createElement('button');
  label.type = 'button';
  label.className = 'rr-collection-header__title rr-collection-header__nav';
  label.textContent = text;
  label.addEventListener('click', () => window.scrollTo({top:0, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
  group.append(label); header.append(group);
  const policyBody = config?.dataset.rrPageKind === 'policy' ? document.querySelector('.shopify-policy__body') : null;
  let sectionNav;
  let sectionLinks = [];
  let clickedSection = null;
  let policyScrollSettling;
  let policyLayoutDirty = true;
  const policyAnchorTop = () => {
    const padding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    return Math.max(padding + 28, header.getBoundingClientRect().bottom + 28) + 75;
  };
  const policyScrollSection = () => {
    let active = sectionLinks[0];
    const threshold = policyAnchorTop() + 12;
    sectionLinks.forEach(entry => { if (entry.heading.getBoundingClientRect().top <= threshold) active = entry; });
    return active;
  };
  const finishPolicyNavigation = () => {
    clearTimeout(policyScrollSettling);
    if (!clickedSection?.navigating) return;
    clickedSection.navigating = false;
    clickedSection.baseline = policyScrollSection();
  };
  const trackPolicyScroll = () => {
    if (clickedSection?.navigating) {
      clearTimeout(policyScrollSettling);
      policyScrollSettling = setTimeout(finishPolicyNavigation, 180);
    }
    schedule();
  };
  const scrollToPolicyAnchor = (target, behavior) => {
    const requestedTop = window.scrollY + target.getBoundingClientRect().top - policyAnchorTop();
    const lastTop = window.scrollY + policyBody.getBoundingClientRect().bottom + 75 - window.innerHeight;
    window.scrollTo({top: Math.max(0, Math.min(requestedTop, lastTop)), behavior});
  };
  const policyRailGeometry = (firstTop, bodyBottom, listHeight, viewportHeight, anchorTop) => {
    const available = Math.max(1, viewportHeight - anchorTop - 24);
    const height = Math.min(listHeight, available);
    const range = Math.max(1, bodyBottom - firstTop - available);
    const progress = Math.min(1, Math.max(0, (anchorTop - firstTop) / range));
    return {
      top: Math.min(Math.max(anchorTop, firstTop), bodyBottom - height),
      height,
      shift: -progress * Math.max(0, listHeight - available)
    };
  };
  const termsGroups = [
    {title: 'Account & Use of Services', sections: [1, 14, 15]},
    {title: 'Products & Jewelry Disclosures', sections: [2]},
    {title: 'Orders, Pricing & Payment', sections: [3, 4, 13]},
    {title: 'Shipping, Delivery, & Risk of Loss', sections: [5]},
    {title: 'Returns, Exchanges, & Cancellations', sections: [6]},
    {title: 'Intellectual Property & Feedback', sections: [7, 12]},
    {title: 'Third Parties & Shopify', sections: [8, 9, 10]},
    {title: 'Privacy', sections: [11]},
    {title: 'Disclaimer of Warranties', sections: [16]},
    {title: 'Limitation of Liability', sections: [17]},
    {title: 'Indemnification', sections: [18]},
    {title: 'Governing Law & Disputes', sections: [22]},
    {title: 'General Terms', sections: [19, 20, 21, 23, 24]},
    {title: 'Contact Information', sections: [25]}
  ];
  const consolidateTerms = () => {
    if (!policyBody || location.pathname !== '/policies/terms-of-service') return;
    const headings = Array.from(policyBody.querySelectorAll('h3')).filter(heading => /^\d+\s*[⬩◇◆.]/.test(heading.textContent.trim()));
    const parent = headings[0]?.parentElement;
    // Fail safely to the original policy if its source structure changes.
    if (headings.length !== 25 || headings.some((heading, index) => heading.parentElement !== parent || parseInt(heading.textContent, 10) !== index + 1)) return;
    const sections = headings.map((heading, index) => {
      const nodes = [];
      for (let node = heading.nextSibling; node && node !== headings[index + 1]; node = node.nextSibling) nodes.push(node);
      const originalText = heading.textContent.trim();
      return {heading, nodes, title: originalText.replace(/^\d+\s*[⬩◇◆.]\s*/, ''), id: heading.id || `rr-policy-${originalText.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`};
    });
    const fragment = document.createDocumentFragment();
    termsGroups.forEach((group, index) => {
      const mainHeading = document.createElement('h3');
      mainHeading.textContent = `${index + 1} ⬩ ${group.title}`;
      mainHeading.id = `rr-policy-group-${group.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`;
      fragment.append(mainHeading);
      group.sections.forEach(number => {
        const section = sections[number - 1];
        if (group.sections.length === 1) {
          mainHeading.id = section.id;
        } else {
          const subheading = document.createElement('h4');
          subheading.id = section.id;
          subheading.className = 'rr-policy-anchor';
          subheading.textContent = section.title;
          fragment.append(subheading);
        }
        // Move original nodes intact: no rewriting or dropping legal paragraphs.
        fragment.append(...section.nodes);
        section.heading.remove();
      });
    });
    parent.append(fragment);
  };
  const buildSections = () => {
    if (!policyBody) return;
    const headings = Array.from(policyBody.querySelectorAll('h2,h3,h4'));
    const numbered = headings.filter(el => /^\d+\s*[⬩◇◆.]/.test(el.textContent.trim()));
    const firstNumbered = headings.indexOf(numbered[0]);
    const sections = numbered.length
      ? headings.filter((el, index) => index < firstNumbered || numbered.includes(el))
      : headings.filter(el => el.tagName === headings[0]?.tagName);
    if (!sections.length) return;
    sectionNav = document.createElement('nav');
    sectionNav.className = 'rr-policy-sections';
    sectionNav.setAttribute('aria-label', text);
    const list = document.createElement('ol');
    sections.forEach((heading, index) => {
      if (!heading.id) {
        const base = `rr-policy-${heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || index + 1}`;
        let id = base, suffix = 2;
        while (document.getElementById(id)) id = `${base}-${suffix++}`;
        heading.id = id;
      }
      heading.classList.add('rr-policy-anchor');
      if (normalize(heading.textContent) === 'overview') return;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      const headingText = heading.textContent.trim();
      const parts = headingText.match(/^(\d+\s*[⬩◇◆.])\s*(.*)$/) ||
        (location.pathname === '/policies/privacy-policy' && heading.tagName === 'H2'
          ? [headingText, `${sectionLinks.length + 1} ⬩`, headingText] : null);
      const marker = document.createElement('span');
      marker.className = 'rr-policy-sections__marker';
      const diamond = document.createElement('span');
      diamond.className = 'rr-policy-sections__diamond';
      diamond.textContent = parts ? parts[1].match(/[⬩◇◆.]/)[0] : '';
      const number = document.createElement('span');
      number.className = 'rr-policy-sections__number';
      number.textContent = parts ? parts[1].match(/^\d+/)[0] : '';
      marker.append(diamond, number);
      const name = document.createElement('span');
      name.className = 'rr-policy-sections__name';
      name.textContent = parts ? parts[2] : headingText;
      link.setAttribute('aria-label', parts ? `${name.textContent} ${diamond.textContent} ${number.textContent}` : headingText);
      link.append(name, marker);
      if (parts) {
        const headingMarker = document.createElement('span');
        headingMarker.className = 'rr-policy-heading-marker';
        const headingNumber = document.createElement('span');
        headingNumber.className = 'rr-policy-heading-number';
        headingNumber.textContent = number.textContent;
        const headingDiamond = document.createElement('span');
        headingDiamond.textContent = ` ${diamond.textContent} `;
        headingMarker.append(headingNumber, headingDiamond);
        const headingName = document.createElement('span');
        headingName.className = 'rr-policy-heading-name';
        const prefix = heading.textContent.match(/^\s*\d+\s*[⬩◇◆.]\s*/)?.[0];
        if (prefix) {
          const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
          let remaining = prefix.length, node;
          while ((node = walker.nextNode())) {
            if (remaining <= node.length) {
              const range = document.createRange();
              range.setStart(heading, 0);
              range.setEnd(node, remaining);
              range.deleteContents();
              break;
            }
            remaining -= node.length;
          }
        }
        headingName.append(...heading.childNodes);
        heading.append(headingMarker, headingName);
        heading.classList.add('rr-policy-numbered-heading');
      }
      link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        history.pushState(null, '', link.hash);
        clickedSection = {entry: sectionLinks.find(entry => entry.link === link), navigating: true, baseline: null};
        trackPolicyScroll();
        heading.setAttribute('tabindex', '-1');
        heading.focus({preventScroll:true});
        scrollToPolicyAnchor(heading, matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
      });
      const item = document.createElement('li');
      item.append(link); list.append(item);
      sectionLinks.push({heading, link});
    });
    sectionNav.append(list);
    const sectionHeadings = new Set(sectionLinks.map(entry => entry.heading));
    sectionLinks.forEach(({heading}) => {
      if (!heading.classList.contains('rr-policy-numbered-heading')) return;
      for (let sibling = heading.nextElementSibling; sibling && !sectionHeadings.has(sibling); sibling = sibling.nextElementSibling) {
        if (!sibling.matches('hr')) sibling.classList.add('rr-policy-section-content');
      }
    });
    const policyLayout = policyBody.closest('.shopify-policy__container');
    policyLayout?.classList.toggle('rr-policy-wide-content', ['/policies/terms-of-service', '/policies/privacy-policy', '/policies/refund-policy', '/policies/shipping-policy'].includes(location.pathname));
    if (policyLayout) policyLayout.append(sectionNav);
  };
  const buildOverview = () => {
    const firstSection = sectionLinks[0]?.heading;
    if (!firstSection) return;
    const range = document.createRange();
    range.setStart(policyBody, 0);
    range.setEndBefore(firstSection);
    if (!range.toString().trim()) return;
    policyBody.firstElementChild?.classList.add('prose');
    const overview = document.createElement('div');
    overview.className = 'rr-policy-overview-panel';
    const content = document.createElement('div');
    content.className = 'rr-policy-overview-content';
    content.append(range.extractContents());
    const existingDivider = Array.from(content.querySelectorAll('div[style], hr')).filter(element =>
      element.tagName === 'HR' || (!element.textContent.trim() && element.style.height === '0.5px' && element.style.background.includes('linear-gradient'))
    ).at(-1);
    const divider = existingDivider || document.createElement('div');
    if (existingDivider) {
      const wrapper = divider.parentElement;
      if (wrapper !== content && wrapper.children.length === 1 && !wrapper.textContent.trim() && !wrapper.matches('.prose, .rte')) wrapper.remove();
    } else {
      divider.style.cssText = 'width:100%;height:0.5px;background:linear-gradient(to right,#000 0%,#fff 30%,#fff 70%,#000 100%)';
      divider.setAttribute('role', 'separator');
    }
    divider.classList.add('rr-policy-overview-divider');
    overview.append(content, divider);
    firstSection.classList.add('rr-policy-first-section');
    policyBody.before(overview);
    policyBody.parentElement.classList.add('rr-policy-has-overview');
    policyLayoutDirty = true;
  };
  const linkReturnRequest = () => {
    if (location.pathname !== '/policies/refund-policy') return;
    const overview = policyBody?.parentElement.querySelector('.rr-policy-overview-content');
    const entry = sectionLinks.find(item => item.heading.id === 'rr-policy-3-starting-a-return');
    if (!overview || !entry) return;
    const walker = document.createTreeWalker(overview, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const phrase = 'request a return';
      const offset = node.textContent.indexOf(phrase);
      if (offset < 0 || node.parentElement.closest('a')) continue;
      const link = document.createElement('a');
      link.href = entry.link.getAttribute('href');
      link.textContent = phrase;
      link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        entry.link.click();
      });
      node.replaceWith(document.createTextNode(node.textContent.slice(0, offset)), link,
        document.createTextNode(node.textContent.slice(offset + phrase.length)));
      break;
    }
  };
  // Policy presentation scripts finish their heading changes on DOMContentLoaded.
  const initSections = () => {
    consolidateTerms();
    buildSections();
    // Keep existing heading IDs, then let all DOMContentLoaded formatters finish
    // (including moving Privacy's date to the end) before splitting the introduction.
    requestAnimationFrame(() => {
      buildOverview();
      linkReturnRequest();
      update();
      // Font metrics determine the final policy rail and content alignment.
      // Reveal only after this last measurement, with a head-level failure fallback.
      if (policyBody) Promise.resolve(document.fonts?.ready).then(() => {
        policyLayoutDirty = true;
        update();
        requestAnimationFrame(() => {
          clearTimeout(window.rrPolicyRevealTimer);
          window.rrPolicyReveal?.();
        });
      });
      if (location.hash && performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') {
        const target = document.getElementById(location.hash.slice(1));
        if (target && policyBody?.parentElement.contains(target)) scrollToPolicyAnchor(target, 'instant');
      }
    });
  };
  const nav = document.getElementById('sidebar-menu');
  const storyPage = location.pathname === '/pages/story-and-expertise';
  let storyLayoutDirty = true;
  let storyGeometry;
  let storyVisible;
  let storyHeadingPassed = false;
  let storyHeadingObserver;
  // Scrolling only needs the heading threshold. Remeasure header geometry when
  // content, fonts, viewport or expanded-header state actually changes.
  const updateStoryHeader = () => {
    if (storyLayoutDirty) {
      const headings = Array.from(main.querySelectorAll('h1,h2,h3,.h1,.h2,.h3,[role="heading"]')).filter(el => el.getClientRects().length && !el.closest('footer, [class*="newsletter"]'));
      const heading = headings.find(el => normalize(el.textContent) === normalize(text)) || headings[0];
      const m = menu.getBoundingClientRect(), h = header.getBoundingClientRect();
      const logo = header.querySelector('.header__logo')?.getBoundingClientRect();
      const left = m.right - h.left + 42;
      const available = (logo?.left || h.right) - left - parseFloat(getComputedStyle(header).getPropertyValue('--rr-logo-clearance'));
      group.style.left = `${left}px`;
      group.style.top = `${m.top - h.top + m.height / 2}px`;
      group.style.maxWidth = `${Math.max(0, available)}px`;
      storyGeometry = { heading, bottom: h.bottom, fits: m.width > 0 && label.getBoundingClientRect().width <= available };
      storyHeadingObserver?.disconnect();
      storyHeadingPassed = !!heading && heading.getBoundingClientRect().bottom <= h.bottom;
      if (heading) {
        storyHeadingObserver = new IntersectionObserver(([entry]) => {
          storyHeadingPassed = entry.boundingClientRect.bottom <= storyGeometry.bottom;
          schedule();
        }, {rootMargin: `-${h.bottom}px 0px 0px 0px`});
        storyHeadingObserver.observe(heading);
      }
      storyLayoutDirty = false;
    }
    const visible = innerWidth >= 700 && !!storyGeometry.heading && storyHeadingPassed && storyGeometry.fits && !nav?.hasAttribute('open');
    if (visible === storyVisible) return;
    storyVisible = visible;
    group.classList.toggle('is-visible', visible);
    group.inert = !visible;
    group.setAttribute('aria-hidden', String(!visible));
  };
  let frame;
  const update = () => {
    frame = null;
    if (storyPage) { updateStoryHeader(); return; }
    const headings = Array.from(main.querySelectorAll('h1,h2,h3,.h1,.h2,.h3,[role="heading"]')).filter(el => el.getClientRects().length && !el.closest('footer, [class*="newsletter"]'));
    const heading = headings.find(el => normalize(el.textContent) === normalize(text)) || headings[0];
    const m = menu.getBoundingClientRect(), h = header.getBoundingClientRect();
    const logo = header.querySelector('.header__logo')?.getBoundingClientRect();
    const policyLayout = policyBody?.closest('.shopify-policy__container');
    const widePolicy = !!policyLayout && innerWidth >= 1200;
    const layoutStyle = widePolicy ? getComputedStyle(policyLayout) : null;
    const open = !!nav?.hasAttribute('open');
    const left = m.right + 42;
    const available = (logo?.left || h.right) - left - parseFloat(getComputedStyle(header).getPropertyValue('--rr-logo-clearance'));
    group.style.left = `${left}px`;
    group.style.top = `${m.top + m.height / 2}px`;
    group.style.maxWidth = `${Math.max(0, available)}px`;
    if (sectionNav) {
      const railWidth = widePolicy ? parseFloat(layoutStyle.gridTemplateColumns) : policyBody.getBoundingClientRect().left - left - 24;
      if (widePolicy && sectionLinks.length && policyLayoutDirty) {
        sectionNav.hidden = false;
        sectionNav.style.width = `${railWidth}px`;
        const range = document.createRange();
        const contentWidth = Math.max(...sectionLinks.map(({link}) => {
          const name = link.querySelector('.rr-policy-sections__name');
          range.selectNodeContents(name);
          return link.getBoundingClientRect().right - range.getBoundingClientRect().left;
        }));
        const contentTrackWidth = parseFloat(layoutStyle.gridTemplateColumns.split(' ')[1]);
        const extraContentWidth = Math.max(0, policyBody.getBoundingClientRect().width - contentTrackWidth);
        policyLayout.style.setProperty('--rr-policy-content-shift', `${(contentWidth - railWidth - extraContentWidth) / 2}px`);
        policyLayout.style.setProperty('--rr-policy-combined-width', `${contentWidth + parseFloat(layoutStyle.columnGap) + policyBody.getBoundingClientRect().width}px`);
        policyLayoutDirty = false;
      }
      sectionNav.hidden = !widePolicy || railWidth < 160 || open;
      const scrollPadding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
      const anchorOffset = policyAnchorTop() - scrollPadding;
      policyBody.style.setProperty('--rr-policy-anchor-offset', `${anchorOffset}px`);
      policyLayout?.style.setProperty('--rr-policy-anchor-offset', `${anchorOffset}px`);
      if (widePolicy && !sectionNav.hidden && sectionLinks.length) {
        const list = sectionNav.firstElementChild;
        sectionNav.style.position = 'sticky';
        sectionNav.style.width = `${railWidth}px`;
        const geometry = policyRailGeometry(
          sectionLinks[0].heading.getBoundingClientRect().top,
          policyBody.getBoundingClientRect().bottom,
          list.getBoundingClientRect().height,
          innerHeight,
          scrollPadding + anchorOffset
        );
        sectionNav.style.top = `${scrollPadding + anchorOffset - 50}px`;
        sectionNav.style.marginTop = `${sectionLinks[0].heading.getBoundingClientRect().top - policyBody.getBoundingClientRect().top - 50}px`;
        sectionNav.style.height = `${geometry.height + 50}px`;
        sectionNav.classList.toggle('has-overflow', list.getBoundingClientRect().height > geometry.height + 1);
        list.style.transform = `translateY(${geometry.shift}px)`;
      }
      const scrollActive = policyScrollSection();
      // A capped destination may leave a preceding heading at the anchor line.
      // Keep the click selection until a subsequent scroll crosses a section boundary.
      if (clickedSection && !clickedSection.navigating && scrollActive !== clickedSection.baseline) clickedSection = null;
      const active = clickedSection?.entry || scrollActive;
      sectionLinks.forEach(entry => {
        if (entry === active) entry.link.setAttribute('aria-current', 'location');
        else entry.link.removeAttribute('aria-current');
      });
    }
    const visible = innerWidth >= 700 && !!heading && heading.getBoundingClientRect().bottom <= h.bottom && m.width > 0 && label.getBoundingClientRect().width <= available && !open;
    group.classList.toggle('is-visible', visible);
    group.inert = !visible;
    group.setAttribute('aria-hidden', String(!visible));

  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const scheduleLayout = () => { policyLayoutDirty = true; storyLayoutDirty = true; schedule(); };
  if (storyPage) {
    new ResizeObserver(scheduleLayout).observe(header);
    const expandedHeader = header.querySelector('x-header');
    if (expandedHeader) new MutationObserver(scheduleLayout).observe(expandedHeader, {attributes:true, attributeFilter:['data-rr-home-expanded']});
    header.addEventListener('transitionend', scheduleLayout);
  }
  if (!storyPage) window.addEventListener('scroll', trackPolicyScroll, {passive:true});
  window.addEventListener('scrollend', finishPolicyNavigation);
  window.addEventListener('wheel', finishPolicyNavigation, {passive:true});
  window.addEventListener('touchmove', finishPolicyNavigation, {passive:true});
  window.addEventListener('keydown', event => {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key) &&
        !event.target.closest('input, textarea, select, [contenteditable="true"]')) finishPolicyNavigation();
  });
  window.addEventListener('resize', scheduleLayout, {passive:true});
  window.addEventListener('pageshow', scheduleLayout);
  document.fonts?.ready.then(scheduleLayout);
  new ResizeObserver(scheduleLayout).observe(main);
  new MutationObserver(scheduleLayout).observe(main, {childList:true, subtree:true, characterData:true});
  if (nav) new MutationObserver(schedule).observe(nav, {attributes:true, attributeFilter:['open']});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSections, {once:true});
  else initSections();
  update();
})();
